import { library } from '@fortawesome/fontawesome-svg-core'
import Vue from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons/faFolderOpen'
import { faFileImage } from '@fortawesome/free-solid-svg-icons/faFileImage'
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers'
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser'
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons/faCloudUploadAlt'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons/faFilePdf'
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile'
import { faFileCsv } from '@fortawesome/free-solid-svg-icons/faFileCsv'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog'
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash'
import { faUnlock } from '@fortawesome/free-solid-svg-icons/faUnlock'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import { faThumbsDown } from '@fortawesome/free-solid-svg-icons/faThumbsDown'
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons/faThumbsUp'
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock'
import { faBell } from '@fortawesome/free-solid-svg-icons/faBell'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons/faAngleDoubleRight'
import { faChartPie } from '@fortawesome/free-solid-svg-icons/faChartPie'
import { faPoll } from '@fortawesome/free-solid-svg-icons/faPoll'
import { faSolarPanel } from '@fortawesome/free-solid-svg-icons/faSolarPanel'
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons/faArrowCircleRight'
import { faGripVertical } from '@fortawesome/free-solid-svg-icons/faGripVertical'
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye'
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay'
import { faPause } from '@fortawesome/free-solid-svg-icons/faPause'
import { faVolumeMute } from '@fortawesome/free-solid-svg-icons/faVolumeMute'
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons/faVolumeUp'
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars'
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload'
import { faUndoAlt } from '@fortawesome/free-solid-svg-icons/faUndoAlt'
import { faArrowsAlt } from '@fortawesome/free-solid-svg-icons/faArrowsAlt'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faFont } from '@fortawesome/free-solid-svg-icons/faFont'
import { faTextWidth } from '@fortawesome/free-solid-svg-icons/faTextWidth'
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons/faPlayCircle'
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit'
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook'
import { faGooglePlus } from '@fortawesome/free-brands-svg-icons/faGooglePlus'
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons/faArrowCircleLeft'
import { faImages } from '@fortawesome/free-solid-svg-icons/faImages'
import { faCamera } from '@fortawesome/free-solid-svg-icons/faCamera'
import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion'
import { faBold } from '@fortawesome/free-solid-svg-icons/faBold'
import { faItalic } from '@fortawesome/free-solid-svg-icons/faItalic'
import { faUnderline } from '@fortawesome/free-solid-svg-icons/faUnderline'
import { faStrikethrough } from '@fortawesome/free-solid-svg-icons/faStrikethrough'
import { faParagraph } from '@fortawesome/free-solid-svg-icons/faParagraph'
import { faListOl } from '@fortawesome/free-solid-svg-icons/faListOl'
import { faListUl } from '@fortawesome/free-solid-svg-icons/faListUl'
import { faCopy } from '@fortawesome/free-solid-svg-icons'

library.add(
  faUsers,
  faUser,
  faCloudUploadAlt,
  faFilePdf,
  faFile,
  faFileImage,
  faFileCsv,
  faFolderOpen,
  faSpinner,
  faCog,
  faTrash,
  faUnlock,
  faCheck,
  faLock,
  faTimes,
  faTimesCircle,
  faCheckCircle,
  faThumbsDown,
  faThumbsUp,
  faClock,
  faBell,
  faExclamationCircle,
  faEnvelope,
  faAngleDoubleRight,
  faChartPie,
  faPoll,
  faSolarPanel,
  faArrowCircleRight,
  faArrowCircleLeft,
  faGripVertical,
  faEye,
  faPlay,
  faPause,
  faVolumeMute,
  faVolumeUp,
  faBars,
  faDownload,
  faUndoAlt,
  faArrowsAlt,
  faPlus,
  faFont,
  faTextWidth,
  faPlayCircle,
  faEdit,
  faFacebook,
  faGooglePlus,
  faImages,
  faCamera,
  faQuestion,
  faExclamationCircle,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faParagraph,
  faListOl,
  faListUl,
  faCopy
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
